import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table-element-operate" }

import { computed, PropType } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore } from '@/store'
import { PPTTableElement } from '@/types/slides'
import { OperateResizeHandlers } from '@/types/edit'
import useCommonOperate from '../hooks/useCommonOperate'

import RotateHandler from './RotateHandler.vue'
import ResizeHandler from './ResizeHandler.vue'
import BorderLine from './BorderLine.vue'


const __default__ = {
  inheritAttrs: false,
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TableElementOperate',
  props: {
  elementInfo: {
    type: Object as PropType<PPTTableElement>,
    required: true,
  },
  handlerVisible: {
    type: Boolean,
    required: true,
  },
  rotateElement: {
    type: Function as PropType<(element: PPTTableElement) => void>,
    required: true,
  },
  scaleElement: {
    type: Function as PropType<(e: MouseEvent, element: PPTTableElement, command: OperateResizeHandlers) => void>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { canvasScale } = storeToRefs(useMainStore())

const outlineWidth = computed(() => props.elementInfo.outline.width || 1)

const scaleWidth = computed(() => (props.elementInfo.width + outlineWidth.value) * canvasScale.value)
const scaleHeight = computed(() => props.elementInfo.height * canvasScale.value)

const { resizeHandlers, borderLines } = useCommonOperate(scaleWidth, scaleHeight)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(borderLines), (line) => {
      return (_openBlock(), _createBlock(BorderLine, {
        class: "operate-border-line",
        key: line.type,
        type: line.type,
        style: _normalizeStyle(line.style)
      }, null, 8, ["type", "style"]))
    }), 128)),
    (__props.handlerVisible)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resizeHandlers), (point) => {
            return (_openBlock(), _createBlock(ResizeHandler, {
              class: "operate-resize-handler",
              key: point.direction,
              type: point.direction,
              rotate: __props.elementInfo.rotate,
              style: _normalizeStyle(point.style),
              onMousedown: _withModifiers($event => __props.scaleElement($event, __props.elementInfo, point.direction), ["stop"])
            }, null, 8, ["type", "rotate", "style", "onMousedown"]))
          }), 128)),
          _createVNode(RotateHandler, {
            class: "operate-rotate-handler",
            style: _normalizeStyle({ left: _unref(scaleWidth) / 2 + 'px' }),
            onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (__props.rotateElement(__props.elementInfo)), ["stop"]))
          }, null, 8, ["style"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})